import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: 'How do I track my order?', a: 'You can track your order from the Track Order page using your order ID and email.' },
    { q: 'What is your return policy?', a: 'We offer 30-day hassle-free returns. Contact support to initiate return.' },
    { q: 'Do you ship internationally?', a: 'Yes, we ship to select countries. Shipping charges vary.' },
    { q: 'How do I find my frame size?', a: 'Check the Frame Size Guide page or look inside your current glasses.' },
    { q: 'Are your lenses anti-glare?', a: 'Yes, all our lenses come with anti-glare coating as standard.' },
  ];

  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Frequently Asked <span className="text-orange-500">Questions</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left focus:outline-none"
              >
                <span className="font-semibold text-gray-800">{faq.q}</span>
                {openIndex === index ? <FaChevronUp className="text-orange-500" /> : <FaChevronDown className="text-orange-500" />}
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 text-gray-600 border-t border-gray-100 pt-3">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;